<template>
<div class="pageCoinRecharge" id="">  
  <XR-head titleText="BAW充值" :rightShow="false" ref="head"></XR-head>
  <div class="login-form">
    <mu-list>
      <mu-list-item title="" describeText="">
        <mu-text-field label="充值账户" fullWidth :disabled="true" v-model="mobile" />
        <mu-icon value=":fa fa-phone" slot="leftAvatar" size="30" style="margin-top:60px;margin-left:-2px" />
      </mu-list-item>
      <mu-list-item title="" describeText="">
        <mu-text-field label="充值BAW" helpText="充值BAW数量" type="number" disabled iconClass="withdrawMoneyText" v-model="rechargeInfo.Baw" fullWidth />
        <mu-avatar src="/static/BAW/baw.png" slot="leftAvatar" size="30" style="margin-top:60px;margin-left:-2px" />
      </mu-list-item>
      <mu-list-item title="" describeText="">
        <mu-text-field label="支付金额" helpText="需要支付的人民币" type="number" disabled iconClass="withdrawMoneyText" v-model="rechargeInfo.Rmb" fullWidth />
        <mu-icon value=":fa fa-rmb" slot="leftAvatar" size="30" style="margin-top:60px;margin-left:-2px" />
      </mu-list-item>
    </mu-list>

    <mu-row gutter class="withdraw-money">
      <mu-col width="100" tablet="100" desktop="33">
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="50" desktop="33" class="login-div">
        <mu-raised-button label="充 值" class="demo-raised-button" primary fullWidth @click="submit()" />
      </mu-col>
    </mu-row>
    <mu-row gutter>
      <mu-col width="100" tablet="50" desktop="33" class="div3">
        <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
      </mu-col>
    </mu-row>
  </div>
</div>
</template>
<script>
import {GUID} from '../../../../util/guid'
import md5 from 'js-md5'
import {ErrorCode} from '../../../../util/errorcode'
export default {
  data () {
    return {
      isShow : 'none',
      rechargeInfo:{
        Baw : '0',
        Rmb : '0'
      },
      mobile:''
    }
  },
  mounted(){
    this.rechargeInfo.RequestID = new GUID().newGUID().replace('-','').replace('-','').replace('-','').replace('-','')
    this.getMemberInfo()
    this.getSiteConfig()
  },
  computed : {
    coinValue(){
      return this.rechargeInfo.Coin>0? parseFloat(this.rechargeInfo.Coin):0
    }
  },
  methods: {
    getSiteConfig(){           
      var ths = this;   
      ths.$post(
        "/Shop/SiteConfigServer/GetSiteConfig"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.rechargeInfo.Baw = res.Data.BAWRechargeCoin
          ths.rechargeInfo.Rmb = res.Data.BAWRechargeRMB
        }
      });      
    },
    close (position) {
      this.PayPopup = false
    },
    getMemberInfo(){  
      var ths = this; 
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          //ths.loaded =false          
          ths.$refs.XRtoast.hide()
          ths.mobile=res.Data.mobile
        }
      });      
    },
    submit:function(){
      this.close()
      this.$refs.XRtoast.load('提交中...')
      var ths = this;  
      ths.$post(
        "/Shop/OnlineRechargeOrderServer/OrderSubmit"
      ).then(function(res) {
        if(!res.IsSuccess){       
          ths.$refs.XRtoast.failed(res.Msg, true)   
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{        
            ths.$router.push("/usercenter/bawRechargePay?orderNo="+res.Data)
        }
      });
    },
    goBack:function(){
      this.$router.goBack()
    }
  }
}

</script>
<style>
#app .pageCoinRecharge{
  background: white;
  bottom: unset;
}
.pageCoinRecharge .login-form {
  padding: 10px 20px 20px 10px;
}
.pageCoinRecharge .login-div {
  padding: 40px 0px 0 20px;
}
.pageCoinRecharge .demo-raised-button {
  height: 50px;
}
.pageCoinRecharge .div2 {
  padding: 20px 0 0 0;
}
.pageCoinRecharge .demo-flat-button.right {
  float: right;
}
.pageCoinRecharge .div3 {
  text-align: center;
  position: absolute;
  bottom: 40px;
  left: 0;
}
.pageCoinRecharge .pageCoinRecharge .notice{
  font-size: 12px;
}
.pageCoinRecharge .sms-button{
  margin-top: 28px;
  margin-bottom: 12px;
}

.pageBAWWithdrawPayPopup{
  width: 100%;
}
.pageBAWWithdrawPayPopup .title{
  font-size: 16px;
  text-align: center;
}
.pageBAWWithdrawPayPopup .withdrawResult{
  font-size: 14px;
  text-align: center;
  padding-top: 20px;
}
.pageBAWWithdrawPayPopup .submit{
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/baw/net/bawRecharge.vue